import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'subs-generic-contact',
  templateUrl: './generic-contact.component.html',
})
export class GenericContactComponent {
  @Input() form: UntypedFormGroup;
  @Input() title: string;
}
